import React, {useEffect, useState} from 'react'
import axios from 'axios'
import LoadingOverlay from 'react-loading-overlay'

import './MidBanner.css'

function MidBanner() {
  const [midBanner, setMidbanner] = useState('')

  const API_URL = process.env.REACT_APP_API_URL

  const [spinnerIsActive, setSpinnerIsActive] = useState(false)
  const [videoInfo, setVideoInfo] = useState('')
  const [imgInfo, setImgInfo] = useState('')

  const getMidbannerInfo = () => {
    setSpinnerIsActive(true)
    axios.get(API_URL + '/midbanner-home').then((response) => {
      document.getElementById('home-midbanner-img').setAttribute('src', response.data.data[0].url)
      setMidbanner(response.data)
      setSpinnerIsActive(false)
    })
  }

  const uploadFile = () => {
    const data = new FormData()

    if (document.getElementById('home-midbanner-file').files.length !== 0) {
      setSpinnerIsActive(true)
      for (let i = 0; i < document.getElementById('home-midbanner-file').files.length; i++) {
        data.append('file[]', document.getElementById('home-midbanner-file').files[i])
      }

      data.append('name', 'home-midbanner-img')

      axios
        .post(API_URL + '/new-midbanner-home', data, {
          // receive two parameter endpoint url ,form data
        })
        .then(
          (res) => {
            console.log(res)
            setMidbanner(res.data.data[0])
            document.getElementById('home-midbanner-img').setAttribute('src', res.data.data[0].url)
            document.getElementsByName('home-midbanner-file')[0].value = null
            setSpinnerIsActive(false)
          },
          (error) => {
            alert(error)
            setSpinnerIsActive(false)
          }
        )
    }
  }

  useEffect(() => {
    getMidbannerInfo()
  }, [])

  return (
    <LoadingOverlay active={spinnerIsActive} spinner text='Cargando...'>
      <div className='row g-5'>
        <div className='col-lg-12'>
          <div className='card card-custom card-stretch shadow mb-5 mid-banner'>
            <div className='card-header'>
              <h3 className='card-title'>Banner Distribuidores</h3>
              <p>
                <span><b>Dimensiones: </b>1920px de ancho por 800px de alto</span><br />
                <span><b>Peso máximo permitido: </b>600kb</span><br />
                <span><b>Formato: </b>JPG o PNG</span><br />
                <span>Incluir la figura verde si se desea conservar</span>
              </p>
            </div>
            <div className='card-body'>
              <div>
                <p>Imagen Actual</p>
                <img src={midBanner.url} id='home-midbanner-img' />

                <div className='row'>
                  <div className='form-group col-md-12 mt-2'>
                    <label>Cambiar imagen:</label>
                    <input
                      type='file'
                      className='form-control'
                      id='home-midbanner-file'
                      name='home-midbanner-file'
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='card-footer'>
              <div className='form-group float-end'>
                <button type='submit' className='btn btn-primary mt-6' onClick={() => uploadFile()}>
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  )
}

export {MidBanner}
